export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.26728C0 0.931178 0.14227 0.60884 0.395512 0.371178C0.648754 0.133517 0.992223 0 1.35036 0H14.854C15.2121 0 15.5556 0.133517 15.8088 0.371178C16.0621 0.60884 16.2043 0.931178 16.2043 1.26728V3.02965C16.2042 3.47775 16.0145 3.90747 15.6768 4.22427L10.8029 8.79832V15.0705C10.8029 15.229 10.7598 15.3848 10.6776 15.5231C10.5954 15.6615 10.4769 15.7779 10.3333 15.8612C10.1897 15.9445 10.0258 15.9919 9.85712 15.9991C9.68848 16.0062 9.52069 15.9727 9.36971 15.9019L6.02351 14.3321C5.83659 14.2444 5.67939 14.1096 5.56952 13.9428C5.45965 13.7759 5.40145 13.5837 5.40145 13.3876V8.79832L0.527541 4.22427C0.189862 3.90747 0.000101975 3.47775 0 3.02965V1.26728Z"
        fill="#215479"
      />
    </svg>
  );
};
